var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 0.461426C2.9461 0.461426 0.461548 2.94598 0.461548 5.99989C0.461548 9.05379 2.94607 11.5383 6 11.5383C9.05392 11.5383 11.5385 9.05379 11.5385 5.99989C11.5385 2.94598 9.05392 0.461426 6 0.461426ZM6 10.6981C3.40938 10.6981 1.30175 8.59051 1.30175 5.99989C1.30175 3.40927 3.40938 1.30163 6 1.30163C8.59064 1.30163 10.6983 3.40927 10.6983 5.99989C10.6983 8.59051 8.59064 10.6981 6 10.6981Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.27147 6.20888V3.49512H5.43127V6.65304L7.59641 8.12851L8.06958 7.4342L6.27147 6.20888Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPending);
export default __webpack_public_path__ + "static/media/pending.3502b0e65d1255bf1f82a4f078291918.svg";
export { ForwardRef as ReactComponent };